import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-overigInkomen-row',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './tekst-overigInkomen-row.component.html',
    styleUrl: './tekst-overigInkomen-row.component.scss',
})
export class TekstOverigInkomenRowComponent implements OnInit {

    @Input() public id!: string;
    public ibAangifte = {} as Aangifte;
    public focusedElementId: string | null = null;
    public year = 2024;
    public actualYear: number = new Date().getFullYear();

    public vrijwilligerMaxPerUur = 0;
    public vrijwilligerMaxPerUurJongere = 0;
    public vrijwilligerMaxPerMaand = 0;
    public vrijwilligerMaxPerJaar = 0;


    constructor(
        public dataService: BokkzIbDataService) {
    }

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((value) => {
            if (value.year !== undefined) {
                this.year = value.year;
            }
            if (this.year == 2024) {
                this.vrijwilligerMaxPerUur = 5;
                this.vrijwilligerMaxPerUurJongere = 2.75;
                this.vrijwilligerMaxPerMaand = 190;
                this.vrijwilligerMaxPerJaar = 1900;
            }
            if (this.year == 2025) {
                this.vrijwilligerMaxPerUur = 5;
                this.vrijwilligerMaxPerUurJongere = 2.75;
                this.vrijwilligerMaxPerMaand = 210;
                this.vrijwilligerMaxPerJaar = 2100;
            }
        })
    }

}
